var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eva-drawer eva-background"},[_c('div',{staticClass:"eva-drawer__inner eva-background eva-border-right",style:({ width: _vm.currentWidth }),on:{"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }